// Re-export useAuth from AuthContext to maintain backward compatibility
import { useAuth as useAuthBase } from '../contexts/AuthContext'
export { useAuth } from '../contexts/AuthContext'

// useIsPlatformAdmin returns whether the signed-in user carries the global
// is_platform_admin flag. Treat an absent/undefined field as `false` so that
// stale auth state cached before the field existed behaves safely.
export function useIsPlatformAdmin(): boolean {
    const { user } = useAuthBase()
    return Boolean(user?.is_platform_admin)
}